import { render, staticRenderFns } from "./AppNewCustomerOrder.vue?vue&type=template&id=637e6442&scoped=true&"
import script from "./AppNewCustomerOrder.vue?vue&type=script&lang=js&"
export * from "./AppNewCustomerOrder.vue?vue&type=script&lang=js&"
import style0 from "./AppNewCustomerOrder.vue?vue&type=style&index=0&id=637e6442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637e6442",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VBtn,VCol,VDatePicker,VDialog,VIcon,VRow,VSelect,VTextField})
